import { FaFacebook, FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';

const socials = [
    {
        id: "conia-facebook-media",
        url: "https://www.facebook.com/conia.uca/",
        icon: <FaFacebook/>
    },
    {
        id: "conia-twitter-media",
        url: "https://twitter.com/conia_uca",
        icon: <FaTwitter/>
    },
    {
        id: "conia-instagram-media",
        url: "https://www.instagram.com/conia_uca/",
        icon: <FaInstagram/>
    },
    {
        id: "conia-youtube-media",
        url: "https://www.youtube.com/c/CongresodeIngenieriayArquitectura",
        icon: <FaYoutube/>
    }
];

const SocialMedia = ({ className="" }) => {
    return (
        <div className={`flex gap-3 ${className}`}>
            {
                socials.map(social => (
                    <a key={social.id} href={social.url}
                        referrerPolicy="no-referrer"
                        target="_blank"  
                        className='p-2 
                            border-conia-icons border-2 border-solid rounded-full
                            hover:text-white hover:bg-conia-icons child:duration-[0ms]
                            text-conia-icons text-2xl md:text-3xl lg:text-3xl' rel="noreferrer" >
                        { social.icon }
                    </a>
                ))
            }
        </div>
    );
}

export default SocialMedia;